import * as React from "react";

import {NavSection} from "@khan/component-side-nav-page-layout";

import KhanmigoPromoMini from "#dashboard-promos-package/khanmigo-promo-mini.tsx";

import type {KhanmigoPromoSectionDetail} from "../homepage-data.ts";

const KhanmigoPromoSection = ({
    section,
}: {
    section: KhanmigoPromoSectionDetail;
}): React.ReactElement => {
    return (
        <NavSection label={section.label} tag="h2">
            <KhanmigoPromoMini />
        </NavSection>
    );
};

export default React.memo(KhanmigoPromoSection);
